/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@mui/styles';

import Grid from '../../../../../../../lib/clear-bi/grid/components/Grid';

const useStyles = makeStyles(() => ({
  grid: {
    height: '89vh',
    overflow: 'hidden',
  },
}));

const RulesConfigGrid = ({
  keyGrid,
  columns,
  options,
  localization,
  actions,
  data,
  isLoading,
  detailPanel
}) => {
  const classes = useStyles();

  return (
    <>
      <Grid
        className={classes.grid}
        keyGrid={keyGrid}
        columns={columns}
        options={options}
        localization={localization}
        actions={actions}
        data={data}
        isLoading={isLoading}
        detailPanel={detailPanel}
      />
    </>
  );
};

RulesConfigGrid.propTypes = {
  keyGrid: PropTypes.number.isRequired,
  columns: PropTypes.array.isRequired,
  options: PropTypes.object.isRequired,
  localization: PropTypes.object,
  actions: PropTypes.array,
  data: PropTypes.array,
  isLoading: PropTypes.bool,
  detailPanel: PropTypes.func.isRequired
};

RulesConfigGrid.defaultProps = {
  localization: {},
  data: [],
  isLoading: false,
  actions: [],
};

export default RulesConfigGrid;
